import React from 'react';
import { CustomInput } from 'reactstrap';

import 'assets/scss/components/npsScale.css';

export const CommentTypeAnswer = () => (
  <div>
    <textarea
      placeholder="Enter your answer"
      className="form-control"
      disabled
    />
  </div>
);

export const NPSScoreAnswer = () => (
  <React.Fragment>
    <div className="custom-radio-button">
      <NPSScale />
    </div>
    <div className="range-slider-container d-md-none d-lg-none">
      <CustomInput
        min={0}
        max={10}
        disabled
        type="range"
        id="exampleCustomRange"
        name="customRange"
        inline
        className="range-slider"
      />
    </div>
  </React.Fragment>
);

const NPSScale = () => {
  const radioButtons = Array(11)
    .fill()
    .map((a, index) => {
      const radioIndex = index;

      return (
        <CustomInput
          key={`nps-${radioIndex}`}
          id={`nps-${radioIndex}`}
          type="radio"
          name="customRadio"
          htmlFor={`nps-${radioIndex}`}
          value={radioIndex}
          label={radioIndex}
          disabled
          inline
        />
      );
    });

  return radioButtons;
};


// WEBPACK FOOTER //
// ./src/components/questions/answers/answerTypes.js